module.exports = __webpack_public_path__ + "img/emoji.d1cbd196.svg";